import { Axios } from "axios";
import { useState, useCallback, useEffect } from "react";
import { APIError } from "../core/_axios";
import { Agency } from "../core/_models";
import { getCurrentAgency, adminGetAgencyByUniqueIdentifier } from "../core/_requests";

function useAgency({
    axios,
    isForCurrentAgency = false,
    agencyUniqueId = null
}: {
    axios: Axios;
    isForCurrentAgency?: boolean;
    agencyUniqueId?: string | null;
}) {

    const [loading, setLoading] = useState(true);
    const [loadingError, setLoadingError] = useState<string | null>(null);
    const [agency, setAgency] = useState<Agency | null>(null);

    const onLoadAgency = useCallback(async () => {
        if (isForCurrentAgency) {
            setLoading(true);
            setLoadingError(null);
            try {
                const currentAgency = await getCurrentAgency(axios);
                setAgency(currentAgency);
            } catch (exception) {
                console.error(exception)
                const errorMessage = exception instanceof APIError ? exception.message : 'An unknown error has occurred. Please try again.'
                setLoadingError(errorMessage)
            } finally {
                setLoading(false)
            }
        } else if (agencyUniqueId) {
            if (!agencyUniqueId) {
                setLoading(false);
                setLoadingError('No agency unique identifier provided.');
                return;
            }
            setLoading(true);
            setLoadingError(null);
            try {
                const updatedAgency = await adminGetAgencyByUniqueIdentifier(axios, agencyUniqueId);
                setAgency(updatedAgency);
            } catch (exception) {
                console.error(exception)
                const errorMessage = exception instanceof APIError ? exception.message : 'An unknown error has occurred. Please try again.'
                setLoadingError(errorMessage)
            } finally {
                setLoading(false)
            }
        } else {
            setLoading(false);
            setLoadingError('No agency unique identifier provided.');
        }
    }, [axios, agencyUniqueId, isForCurrentAgency]);

    useEffect(() => {
        onLoadAgency();
    }, [onLoadAgency]);

    return {
        loading,
        loadingError,
        agency,
        setAgency,
        onLoadAgency
    };
}

export default useAgency;